define('meetings/lib/phone-number-change/phone-number-change',['require','exports','module','knockout','lodash','api-access','moment','invite-component/invite-component-container','plugins/router','meeting-id'],function (require, exports, module) {
    var ko = require('knockout');
    var _ = require('lodash');
    var numbersApi = require('api-access').numbers;
    var moment = require('moment');
    var Invite = require('invite-component/invite-component-container');
    var router = require('plugins/router');

    require('meeting-id');

    var PhoneNumberChange = function () {
        var self = this;

        self.meetings = ko.observableArray();

        self.notify = function (meetingId) {
            numbersApi.updatePhoneNumberChanges(meetingId)
                .then(function () {
                    Invite.show(meetingId, true)
                        .always(function () {
                            // update meetings
                            self.getMeetings();
                        });
                });
        };

        self.getMeetings = function () {
            return numbersApi.phoneNumberChanges()
                .then(function (data) {
                    if (data.length === 0) {
                        router.navigate('/');
                    }

                    self.meetings(data);
                });
        };

        self.meetingsComputed = ko.computed(function () {
            // populate meeting info and format dates
            var results = [];

            _.forEach(self.meetings(), function (data) {
                data.phoneExpirationTime = moment(data.phoneExpirationTime).format('MMMM D, YYYY');

                if (data.meeting.startTime) {
                    data.meeting.startTime = moment(data.meeting.startTime).format('MMMM D, YYYY h:mm a');
                }

                results.push(data);
            });

            return self.meetings(results);
        });

        self.canActivate = function () {
            return numbersApi.phoneNumberChanges()
                .then(function (data) {
                    if (data.length === 0) {
                        router.navigate('/');
                        return false;
                    }
                    self.meetings(data);
                    return true;
                });
        };
    };

    module.exports = PhoneNumberChange;
});

